import provincesData from '@constants/CityData.json';
import AutoComplete from './AutoComplete';
import { LoaderBtn } from '../../loading/Loader';
import MapSelect from '../../Map/MapSelect/MapSelect';
import InputText from '@/core/Input/InputText';

export default function Step3({ formikSignUpRealestate, setStep, loading }) {
  const filterCity = formikSignUpRealestate.values.province
    ? provincesData.find((item) => item.province === formikSignUpRealestate.values.province)?.cities
    : [];

  return (
    <form
      onSubmit={formikSignUpRealestate.handleSubmit}
      className="grid grid-cols-2 lg:grid-cols-4 gap-x-2 gap-y-8 lg:gap-x-3 lg:gap-y-10 w-full max-w-[650px]"
    >
      <div className="flex flex-col relative gap-1 col-span-2 lg:col-span-2">
        <AutoComplete
          name="province"
          title="استان"
          placeholder="استان را وارد کنید"
          data={provincesData}
          required={true}
          value={formikSignUpRealestate.values.province || ''}
          errors={formikSignUpRealestate.errors.province}
          touched={formikSignUpRealestate.touched.province}
          handleBlur={formikSignUpRealestate.handleBlur}
          setFieldValue={formikSignUpRealestate.setFieldValue}
        />
      </div>

      <div className="flex flex-col relative gap-1 col-span-2 lg:col-span-2">
        <AutoComplete
          name="city"
          title="شهر"
          placeholder="شهر را وارد کنید"
          data={filterCity}
          required={true}
          value={formikSignUpRealestate.values.city || ''}
          errors={formikSignUpRealestate.errors.city}
          touched={formikSignUpRealestate.touched.city}
          handleBlur={formikSignUpRealestate.handleBlur}
          setFieldValue={formikSignUpRealestate.setFieldValue}
        />
      </div>

      <div className="flex flex-col relative gap-1 col-span-2 lg:col-span-4">
        <InputText
          name="address"
          title="آدرس آژانس"
          placeholder="آدرس دقیق را وارد کنید"
          value={formikSignUpRealestate.values.address || ''}
          errors={formikSignUpRealestate.errors.address}
          touched={formikSignUpRealestate.touched.address}
          handleBlur={formikSignUpRealestate.handleBlur}
          handleChange={formikSignUpRealestate.handleChange}
        />
      </div>

      <MapSelect
        formik={formikSignUpRealestate}
        field={formikSignUpRealestate.values.coordinate}
        title="موقعیت آژانس"
        height="200"
      />

      <div className="flex w-full items-center gap-4 col-span-2 lg:col-span-1">
        <button disabled={loading} type="submit" className="btn btn-primary w-full lg:w-fit">
          {loading ? <LoaderBtn /> : 'تایید و ادامه'}
        </button>
        <button onClick={() => setStep(2)} className="btn border-[1px] border-primary text-primary w-full lg:w-fit">
          مرحله قبل
        </button>
      </div>
    </form>
  );
}
